import DEC112_BANNER from "../media/image/dec112-banner.png";

import MAP_MAIN_MARKER from "../media/image/marker-icon-main.png";
import MAP_MAIN_MARKER_RETINA from "../media/image/marker-icon-main-2x.png";

import MAP_DEFAULT_MARKER from "../media/image/marker-icon.png";
import MAP_DEFAULT_MARKER_RETINA from "../media/image/marker-icon-2x.png";

export default {
  DEC112_BANNER,
  
  MAP_DEFAULT_MARKER,
  MAP_DEFAULT_MARKER_RETINA,
  
  MAP_MAIN_MARKER,
  MAP_MAIN_MARKER_RETINA,
}